import React from 'react';
import { oneOfType, number, string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import styled from 'styled-components';
import Base, { H2, Icon, Root, P, FADE_TIMEOUT, ImgContainer, CopyContainer } from '../Base';
import { hasNoLimit } from '../../../util/insuranceDetails';

const Copy = styled(CopyContainer).withConfig({ componentId: 'sc-1bcfxl-0' })`
  margin-top: 24px;
`;

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ carrier: Validator<string>; deductibleAmou... Remove this comment to see the full error message
class Greeting extends Base {
  static propTypes = {
    carrier: string.isRequired,
    deductibleAmountIndividualInNetwork: oneOfType([number, string]).isRequired,
    firstName: string.isRequired,
    planName: string.isRequired,
    planType: string.isRequired,
  };

  static isVisible = () => true;

  icon = '/images/insurance_tutorial/you_have_insurance.svg';

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
  hasNoDeductible = () => hasNoLimit(this.props.deductibleAmountIndividualInNetwork);

  render = () => {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'carrier' does not exist on type 'Readonl... Remove this comment to see the full error message
      carrier,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
      deductibleAmountIndividualInNetwork,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'firstName' does not exist on type 'Reado... Remove this comment to see the full error message
      firstName,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'planName' does not exist on type 'Readon... Remove this comment to see the full error message
      planName,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'planType' does not exist on type 'Readon... Remove this comment to see the full error message
      planType,
    } = this.props;

    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root data-testid="PersonalizedGreeting">
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>
          <Copy>
            <H2>Hi {firstName},</H2>
            <P>
              We're here to help you understand your{' '}
              <b>{this.getCarrierNameTypeString({ carrier, planName, planType })}</b> plan.
            </P>
            {planType.toUpperCase() === 'COMMERCIAL' && <P>Health insurance can be confusing.</P>}
            {planType.toUpperCase() !== 'COMMERCIAL' && (
              <P>
                Health insurance can be confusing. Maybe you're thinking&mdash;what's a{' '}
                <b>{planType.toUpperCase()}</b>?
              </P>
            )}
            {this.hasNoDeductible() && <P>What does having no deductible mean?</P>}
            {!this.hasNoDeductible() && (
              <P>
                How does my <b>${deductibleAmountIndividualInNetwork}</b> deductible work? Or, what
                can I get for <b>free</b>?
              </P>
            )}
            <P>Let's get you some answers...</P>
          </Copy>
        </Root>
      </Fade>
    );
  };
}

export default Greeting;
